import { Cookie } from '@vue-util/cookie';

export const getLoyaltyStatus = () => {
  if (import.meta.server) return false;
  const onlineUID = Cookie.get('macys_online_uid');
  const loyaltyStorageData = localStorage.getItem(`hnfsr_${onlineUID}`);
  let loyaltyData = {};

  if (loyaltyStorageData) {
    try {
      loyaltyData = JSON.parse(loyaltyStorageData) || {};
    } catch (e) {
      // loyaltyStorageData is not valid JSON, default to empty object.
      console.log('Error parsing loyalty data from localStorage:', e);
    }
  }
  if (
    loyaltyData.encryptedLoyaltyId ||
    (!loyaltyData.encryptedLoyaltyId &&
      ((loyaltyData.walletCardsIndicator && loyaltyData.walletCardsIndicator !== 'NoCards') || loyaltyData.isLtyIdLinked))
  ) {
    return true; // no banner
  }
  return false; // show banner
};
